import { useTranslation } from '@/i18n/translations';
import { useNavigate } from 'react-router-dom';
import { Instagram, Linkedin, Youtube } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const links = [
    { label: t('footer.features'), onClick: () => (window.location.href = '/#features') },
    { label: t('footer.pricing'), onClick: () => (window.location.href = '/#pricing') },
    { label: t('blog.title'), onClick: () => navigate('/blog') },
    { label: 'Partners', onClick: () => navigate('/partner') },
  ];

  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <img src="/logo-header.png" alt="Chatity" className="h-7 w-auto" />
            <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-600">
              {links.map((l) => (
                <button key={l.label} onClick={l.onClick} className="hover:text-black transition-colors">
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-5 text-gray-500">
            <a href="https://instagram.com/chatity.io" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-black transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="hover:text-black transition-colors"><Linkedin className="w-5 h-5" /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-black transition-colors"><Youtube className="w-5 h-5" /></a>
          </div>
          <div className="text-center lg:text-right text-sm text-gray-500">
            <p>© {new Date().getFullYear()} Chatity. All rights reserved.</p>
            <div className="flex justify-center lg:justify-end gap-4 mt-1">
              <button onClick={() => navigate('/privacy-policy')} className="hover:text-black transition-colors">{t('footer.privacyPolicy')}</button>
              <button onClick={() => navigate('/terms-of-service')} className="hover:text-black transition-colors">{t('footer.termsOfService')}</button>
              <button onClick={() => navigate('/dpa')} className="hover:text-black transition-colors" data-testid="footer-dpa-link">DPA</button>
              <button onClick={() => navigate('/subprocessors')} className="hover:text-black transition-colors" data-testid="footer-subprocessors-link">Subprocessors</button>
              <button onClick={() => navigate('/legal-notice')} className="hover:text-black transition-colors" data-testid="footer-legal-notice-link">Mentions légales</button>
              <a href="mailto:hello@chatity.io" className="hover:text-black transition-colors">{t('footer.contact')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
